import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20toned%20flat%20lay%20composition%20of%20fashion%20items%20including%20sneakers%2C%20hoodies%2C%20accessories%20on%20cream%20background%2C%20minimalist%20European%20aesthetic%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%20with%20warm%20beige%20and%20terracotta%20accents%2C%20organic%20textures%2C%20elevated%20product%20photography%2C%20no%20harsh%20shadows%2C%20airy%20composition&width=1600&height=900&seq=hero-bg-yoybuy&orientation=landscape"
          alt="YOYBUY Spreadsheet fashion items background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full pt-24 pb-16 px-4 md:px-6">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start gap-12 lg:gap-0">
          <div className="w-full lg:w-3/5">
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading font-bold text-background-50 leading-tight">
              {t('hero.title1')}
              <br />
              <span className="italic font-normal text-primary-300">{t('hero.title2')}</span>
              <br />
              {t('hero.title3')}
            </h1>
          </div>

          <div className="w-full lg:w-2/5 lg:pl-10 lg:pt-6">
            <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-8 max-w-md">
              {t('hero.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3.5 rounded-full border-2 border-background-50 text-background-50 text-sm font-medium hover:bg-background-50 hover:text-foreground-900 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
              >
                {t('hero.ctaSpreadsheet')}
              </a>
              <a
                href="#categories"
                className="px-7 py-3.5 rounded-full border-2 border-primary-400 text-primary-300 text-sm font-medium hover:bg-primary-400 hover:text-background-50 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
              >
                {t('hero.ctaCategories')}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-background-50/60">
          <i className="ri-arrow-down-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}